import { render, staticRenderFns } from "./CustomSlider.vue?vue&type=template&id=f541bad8&scoped=true&"
import script from "./CustomSlider.vue?vue&type=script&lang=js&"
export * from "./CustomSlider.vue?vue&type=script&lang=js&"
import style0 from "./CustomSlider.vue?vue&type=style&index=0&id=f541bad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f541bad8",
  null
  
)

export default component.exports